export default __webpack_public_path__ + "static/media/arrow_drop_down-24px.87e5b431.svg";